import {
  CHANGE_WITH_MEMBERSHIP_BOARD_RECURSIVE,
} from './actions'

const initialState = {
  with_membership_board_recursive: false,
}

export const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_WITH_MEMBERSHIP_BOARD_RECURSIVE:
      return {
        ...state,
        with_membership_board_recursive: action.payload,
      }

    default:
      return state
  }
}

export default configReducer
